import fr from "./fr.js";
import en from "./en.js";
import de from "./de.js";
export const messages = { en: en, fr: fr, de: de };
